<template>
    <button class="ds-btn" type="button">
        <img class="ds-btn__img" :src="shape.img" />
        <span class="ds-btn__label">{{ shape.label }}</span>
    </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

interface Shape {
    img: string;
    label: string;
}

export default defineComponent({
    name: "DiamondShapeButton",
    props: {
        shape: {
            type: Object,
            required: true
        }
    }
});
</script>
